import { render, staticRenderFns } from "./RFMChartPanel.vue?vue&type=template&id=b7d8e960&scoped=true"
import script from "./RFMChartPanel.vue?vue&type=script&lang=js"
export * from "./RFMChartPanel.vue?vue&type=script&lang=js"
import style0 from "./RFMChartPanel.vue?vue&type=style&index=0&id=b7d8e960&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7d8e960",
  null
  
)

export default component.exports